import { useState } from 'react';
import { useUserContextPreferences } from '../../../../hooks/useUserContextPreferences';
import { FilterPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { sleep } from '../../../../utils/generics';
import useMultiDynamicOptionsSelector from '../../../Crud/filters/hooks/multiOptionsSelectorFilter/useMultiDynamicOptionsSelector/useMultiDynamicOptionsSelector';
import { MultiDynamicOptionsCreatorFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { useFilterV3Context } from '../../contexts/FilterV3.context';

export interface DynamicOptionsSelectorsCreatorPropsV2 {
  option: MultiDynamicOptionsCreatorFilter;
  onClickApply: () => void;
  list?: FilterPreferenceRecognizedLists;
}

const useDynamicOptionsSelectorsCreatorV2 = ({
  option,
  list,
  onClickApply,
}: DynamicOptionsSelectorsCreatorPropsV2) => {
  const { menu } = useFilterV3Context();

  const { getDefaultFiltersToList } = useUserContextPreferences();
  const defaultFilters = list ? getDefaultFiltersToList(list) : null;

  const { hookArgs, dynamicOptionQueryFn, dynamicOptionQueryKey, keys } =
    option.multiDynamicOptionsCreatorArgs;

  const data = menu.data as Record<string, unknown>;
  const filterKey = `${keys.idsPrefix}${data[keys.filterId as string]}`;

  const filterLogic = useMultiDynamicOptionsSelector({
    ...hookArgs,
    key: filterKey,
    defaultValues: defaultFilters?.[filterKey],
    debounceTime: 10,
    queryFn: (params) =>
      dynamicOptionQueryFn({
        ...params,
        [keys.keyToRequestOptions as string]: data[keys.filterId as string],
      }),
    queryKeyFn: (params) =>
      dynamicOptionQueryKey({
        ...params,
        [keys.keyToRequestOptions as string]: data[keys.filterId as string],
      }),
  });

  const [internalState, setInternalState] = useState(filterLogic.selectedOptions);

  const handleClickApply = async () => {
    filterLogic.setSelectedOptions(internalState);
    await sleep(15); // TODO: solução temporária enquanto houver debounce na hook useMultiDynamicOptionsSelector
    onClickApply();
  };

  return {
    handleClickApply,
    onChangeState: setInternalState,
    state: internalState,
    filterLogic,
  };
};

export default useDynamicOptionsSelectorsCreatorV2;
